import { render, staticRenderFns } from "./overtime.vue?vue&type=template&id=770c0dd2&scoped=true"
import script from "./overtime.vue?vue&type=script&lang=js"
export * from "./overtime.vue?vue&type=script&lang=js"
import style0 from "./overtime.vue?vue&type=style&index=0&id=770c0dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "770c0dd2",
  null
  
)

export default component.exports